<template>

<div class="Review">
<div class="container">
  <button type="button" @click="closeModel()" data-dismiss="modal" aria-label="Close" class="close"><span aria-hidden="true">×</span></button>
  <div class="rating">
    <img src="@/./assets/website/img/rating.jpg">
	<h2 class="title text-center mt-4">{{ $t("message.givefeedback", {}, { locale: lang }) }}</h2>
  </div>

<div class="row mb-3 mt-4">
                <div class="col">
               
					<form>
						<textarea class="form-control" maxlength="40" rows="2" id="user_instruction" :placeholder="$t('message.telluswhat', {}, { locale: lang })"></textarea>
					</form>
					
                </div> 
            </div>


			<div class="row">
				<div class="col-md-12 text-center">
					<button @click="submitFeedback();" class="genric-btn danger circle mb-3" style="font-size:15px; box-shadow: 2px 2px 7px #a7a7a7;">
                {{ $t("message.submitfeedback", {}, { locale: lang }) }}</button>
				</div>
			</div>
</div>		
</div>

</template>

<script>

import "@meforma/vue-toaster";

export default {
  name: 'Review',
  data: function (){
    return {     
      lang: '', 
    }
  },
  methods : {
    closeModel: function(){
      localStorage.removeItem('session_id');
      localStorage.removeItem('pin');
      localStorage.removeItem('order_id');
      localStorage.removeItem('grand_total');
      localStorage.removeItem('direct_order');
        this.$router.push(
          "/" + localStorage.getItem('restaurant_id') + "/" + localStorage.getItem('table_id')
        );
    },
    submitFeedback: function(){
      var data = new this.formdata();
      data.append("session_uuid", localStorage.getItem('session_id'));
      data.append("feedback", this.jQuery("#user_instruction").val());
      data.append("rating", 0);
      var configSession = {
        method: "post",
        data: data,
        url:
          process.env.VUE_APP_BASE_URI +
          "/api/userapi/feedback/",
        headers: {},
      };
      this.axios(configSession).then((response) => {
        if (response.status) {

          this.$toast.success(this.$t("message.feedback_success", {}, { locale: this.lang }),{
                position:"bottom",
                duration:2000
          })
          localStorage.removeItem('session_id');
          localStorage.removeItem('pin');
          localStorage.removeItem('order_id');
          localStorage.removeItem('grand_total');
          localStorage.removeItem('direct_order');
        this.$router.push(
          "/" + localStorage.getItem('restaurant_id') + "/" + localStorage.getItem('table_id')
        );
        }
      });
    },
    
  },
  mounted: function(){
    // let _this = this;
    var lang = localStorage.getItem('lang');
    this.lang = lang;
    window.onhashchange = function() {
        
        // var order_detail_url = window.location.hash;
        localStorage.removeItem('session_id');
          localStorage.removeItem('pin');
          localStorage.removeItem('order_id');
          localStorage.removeItem('grand_total');
          localStorage.removeItem('direct_order');
         // localStorage.removeItem('email')
          //localStorage.removeItem('phone')
          //localStorage.removeItem('name')
          localStorage.removeItem('personal_detail')
          localStorage.removeItem('instruction')

        window.location.href= '#/'+localStorage.getItem('restaurant_id')+'/'+localStorage.getItem('table_id');

        // alert(order_detail_url)
    }
}
}
</script>